export default __webpack_public_path__ + "static/media/Leggings of Clawing Might.35974c49.jpg";